import React from 'react';
import Entry from '../entry';
import { Flex, Text, Box } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import trailWinner from '../../gifs/trailWinner.gif'

export default () => {
  const title = 'Holiday Hack Trail';
  const hints = [(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Minty Candycane] </Text><a href="https://www.youtube.com/watch?v=0T6-DQtzCgM&feature=youtu.be">Web Apps: A Trailhead</a></Flex>),
];
  const assignment = `Hi! I'm Minty Candycane!
I just LOVE this old game!
I found it on a 5 1/4" floppy in the attic.
You should give it a go!
If you get stuck at all, check out this year's talks.
One is about web application penetration testing.
Good luck, and don't get dysentery!`;
  const data = useStaticQuery(graphql`
    query {
      hhtCode: file(relativePath: { eq: "hhtCode.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      hhtHint: file(relativePath: { eq: "hhtHint.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      cranHht: file(relativePath: { eq: "cranHht.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      hhtFromYoutube: file(relativePath: { eq: "hhtFromYoutube.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      hhtNoBurp: file(relativePath: { eq: "hhtNoBurp.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      hhtStatusContainer: file(relativePath: { eq: "hhtStatusContainer.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      hhtYasMax: file(relativePath: { eq: "hhtYasMax.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      hhtHardLast: file(relativePath: { eq: "hhtHardLast.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }


    }
  `);
  const extra = (
    <>
    <Img fluid={data.cranHht.childImageSharp.fluid}
            style={{ margin: 0,  maxHeight: '35vh', width: '72vw' }}
            imgStyle={{ objectFit: 'contain' }}
    />
    <Text mb={1} fontSize='13px' alignSelf='center'>Location: Dormitory Hallway</Text>
    </>
  );

  return (
    <Entry
      title={title}
      hints={hints}
      extra={extra}
      assignment={assignment}
    >
      <Text my={2}>Since the terminal is an iframe... it could be better to beat the game at <code>https://trail.elfu.org</code>, which can be discovered in the Network Tab of browser Dev Tools upon the terminal opening. Like Chris suggested in the video, let's look at the page source and see if we can find anything.</Text>
      <Img fluid={data.hhtHint.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '35vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>Forgotten comments in the source reveal a lot. They show the technique how each level can be beat. We will go for level Hard! It mentions hash... </Text>
      <Img fluid={data.hhtFromYoutube.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '70vh', width: '72vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>The screenshot above is taken from Chris's YouTube video. That's very nice of him to reveal what happens on the backend and which field values are summed up and hashed with MD5. Now let's worry about POST request body. No Burp necessary, we can see it all at the Network Tab of browser Dev Tools.</Text>
      <Img fluid={data.hhtNoBurp.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '70vh', width: '72vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>In the Page Source all those key-value pairs live inside the <code>#statusContainer</code></Text>
      <Img fluid={data.hhtStatusContainer.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '70vh', width: '72vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>And nothing prevents us from modifying these values through the Dev Tool console with JavaScript! The backend code that Chris leaked tells us which fields we need for the hash. By trial and error I figured out the maximum acceptable value for each of the fields below. Well, for distance all we really need is 8000. The day and month remain constant: 1 and 9. The sum of day, month and all the values below is <code>270660</code>. Then we get MD5 hash of <code>270660</code>, which is <code>89a8ba25755f8733d773e708ad16020a</code>, and add that value to appropriate place.</Text>
      <Img fluid={data.hhtCode.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '70vh', width: '72vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>When on "store" screen, we paste the code above to the Dev Tools console and press Enter. Then press "Buy" in the game. Look at all the goodies we have!</Text>
      <Img fluid={data.hhtYasMax.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '70vh', width: '72vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>Now we're one click away from winning!</Text>
      <Box><img height="60%" width="60%" src={trailWinner} alt="nyancat rainbow" /></Box>

      <Text my={2}>In the Source of the winning page there is an intriguing comment. Can we use that for something else later? (Yes, Objective 11)</Text>
      <Img fluid={data.hhtHardLast.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '70vh', width: '72vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
    </Entry>
  )

};
